import React from 'react';
import { groupBy, map, without } from 'lodash';

import FieldCheckboxGroup from '@magoosh/lib/formik_inputs/field_checkbox_group';

import { FilterConfig } from './types';

interface Props {
  filterConfig: FilterConfig;
  onChange: (updatedValue: string) => void;
  value: string;
}

// For use within a Formik form
const CheckboxFilter: React.FC<Props> = (props) => {
  let options = props.filterConfig.options;
  if (props.filterConfig.all) {
    options = [{ name: 'All', value: 'all' }].concat(options);
  }

  let groups = groupBy(options, 'group');

  const handleValuesChanged = (selectedValues: string[]) => {
    if (selectedValues.indexOf('all') !== -1) {
      if (props.value.indexOf('all') === -1) {
        props.onChange('all');
      } else {
        props.onChange(without(selectedValues, 'all').join(','));
      }
    } else if (!selectedValues.length)  {
      props.onChange('all');
    } else {
      props.onChange(selectedValues.join(','));
    }
  };

  return (
    <div className="d-flex flex-column">
      {
        map(groups, (groupOptions, groupName) => (
          <div key={groupName}>
            {groupName && groupName !== 'undefined' && <div><strong>{groupName}</strong></div>}

            <FieldCheckboxGroup
              formGroupClassName="u-margin-A-n"
              name={props.filterConfig.key}
              onChange={handleValuesChanged}
              selected={props.value.split(',')}
              optionsArray={groupOptions.map((option) => (
                {
                  displayName: option.name,
                  value: option.value
                }
              ))}
            />
          </div>
        ))
      }
    </div>
  );
};

export default CheckboxFilter;
